import React, { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { ArrowRight } from 'lucide-react';
export function Registration() {
  // Using the provided Formspree ID
  const [state, handleSubmit] = useForm('mldpdorl');
  const [formData, setFormData] = useState({
    name: '',
    title: '',
    company: '',
    email: '',
    phone: '',
    smsConsent: false
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  // If form is successfully submitted
  if (state.succeeded) {
    return <section id="register" className="py-24 bg-[#FFF8DC]" data-id="element-146" data-mp="2ysi4udmzwo9l">
        <div className="container mx-auto px-4 md:px-6" data-id="element-147" data-mp="2yu33aecfkrcq">
          <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-2xl overflow-hidden border border-[#D2691E]" data-id="element-148" data-mp="32un01gt3dsyc">
            <div className="bg-[#2F1B10] p-8 text-center" data-id="element-149" data-mp="37t7vl2xefogg">
              <h2 className="text-3xl font-bold text-white font-serif" data-id="element-150" data-mp="3uyn2ii7gtvt7">
                Registration Received
              </h2>
            </div>
            <div className="p-12 text-center" data-id="element-151" data-mp="3qv8jrjs571c2">
              <div className="mb-6 text-[#556B2F] flex justify-center" data-id="element-152" data-mp="3lwxaba5resud">
                <div className="w-20 h-20 bg-[#556B2F] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-153" data-mp="3lz9xc1qdjtea">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-154" data-mp="iggpm5ka1ys1">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-155" data-mp="8p2l1jdgy8s1" />
                  </svg>
                </div>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-[#2F1B10]" data-id="element-156" data-mp="wfpu47z4f4g6">
                Yeehaw! We got your details.
              </h3>
              <p className="text-lg text-[#556B2F] mb-8" data-id="element-157" data-mp="2qqg3fl62gpdu">
                Complete your registration by securing your ticket below.
              </p>

              <a href="https://buy.stripe.com/3cIcN63e84oWgvrazF4Ni02" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-[#D2691E] hover:bg-[#A0522D] text-white font-bold text-lg px-10 py-4 rounded-lg transition-all shadow-lg hover:shadow-[#D2691E]/30 transform hover:-translate-y-0.5" data-id="element-158" data-mp="2gxh5hcoojmhk">
                Pay $650 — Secure Your Seat
                <ArrowRight size={20} data-id="element-159" data-mp="22yr9y1hiduvb" />
              </a>

              <p className="text-sm text-[#556B2F] mt-4 opacity-70" data-id="element-160" data-mp="22zaqbdrigb78">
                You'll be redirected to our secure payment page
              </p>

              <div className="mt-8 pt-6 border-t border-[#E5E5E5]" data-id="element-161" data-mp="174cpi70x3qe">
                <button onClick={() => window.location.reload()} className="text-[#D2691E] font-bold hover:underline text-sm" data-id="element-162" data-mp="15bf0see1tuj">
                  Return to homepage
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>;
  }
  return <section id="register" className="py-24 bg-[#FFF8DC] relative" data-id="element-163" data-mp="fcefp2q4fvm1">
      <div className="container mx-auto px-4 md:px-6" data-id="element-164" data-mp="fb3bj1srklue">
        <div className="max-w-5xl mx-auto" data-id="element-165" data-mp="u0izka0wud6e">
          <div className="text-center mb-16" data-id="element-166" data-mp="p2pwhpuwlzac">
            <h2 className="text-4xl md:text-5xl font-bold text-[#2F1B10] font-serif mb-4" style={{
            fontFamily: 'Rockwell, "Courier New", serif'
          }} data-id="element-167" data-mp="p1obask6bwew">
              Reserve Your Seat
            </h2>
            <div className="w-24 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-168" data-mp="34tly8bk8fw3e"></div>
            <p className="mt-6 text-xl text-[#556B2F] max-w-2xl mx-auto" data-id="element-169" data-mp="34votba08sfez">
              Space is strictly limited to 50 attendees. Secure your spot at the
              table.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-[#D2691E]" data-id="element-170" data-mp="378ilakerkbbt">
            <div className="grid grid-cols-1 md:grid-cols-5" data-id="element-171" data-mp="3ba43mla2hhte">
              <div className="md:col-span-2 bg-[#2F1B10] p-10 text-white flex flex-col justify-between relative overflow-hidden" data-id="element-172" data-mp="3bax454ifnb33">
                <div className="absolute inset-0 opacity-20" style={{
                backgroundImage: 'url("https://www.transparenttextures.com/patterns/wood-pattern.png")'
              }} data-id="element-173" data-mp="2jiy3i4ucjk44"></div>
                <div className="relative z-10" data-id="element-174" data-mp="2shjhdmoviayk">
                  <h3 className="text-2xl font-bold font-serif mb-6 text-[#F4A460]" data-id="element-175" data-mp="2xamajtpqnie8">
                    What's Included
                  </h3>
                  <ul className="space-y-4" data-id="element-176" data-mp="1zsw2q9ymqjtz">
                    <li className="flex items-start gap-3" data-id="element-177" data-mp="24tjuixuon4p9">
                      <span className="text-[#D2691E] mt-1" data-id="element-178" data-mp="24rp4x68guoeu">✓</span>
                      <span className="text-gray-300" data-id="element-179" data-mp="1x97p6i9zyddf">
                        Full day of workshops & sessions
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-180" data-mp="1nbtlzkd33l32">
                      <span className="text-[#D2691E] mt-1" data-id="element-181" data-mp="1neftjjzz60la">✓</span>
                      <span className="text-gray-300" data-id="element-182" data-mp="1j9zqdqhqx79r">
                        Breakfast, Lunch & Snacks
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-183" data-mp="19l80rp05qz20">
                      <span className="text-[#D2691E] mt-1" data-id="element-184" data-mp="19jn864xelq6s">✓</span>
                      <span className="text-gray-300" data-id="element-185" data-mp="14mws3hllmuld">
                        Private Dinner at Franklin BBQ
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-186" data-mp="vkxaoo6o9ohw">
                      <span className="text-[#D2691E] mt-1" data-id="element-187" data-mp="vkdqt1xgoq18">✓</span>
                      <span className="text-gray-300" data-id="element-188" data-mp="qn57uz4hohyx">
                        Networking with 50+ CFOs
                      </span>
                    </li>
                  </ul>
                </div>

                <div className="mt-12 relative z-10" data-id="element-189" data-mp="l14njvbdab70">
                  <p className="text-sm text-[#F4A460] uppercase tracking-widest mb-2" data-id="element-190" data-mp="kxqoox1wwk4b">
                    Ticket Price
                  </p>
                  <p className="text-4xl font-bold font-serif" data-id="element-191" data-mp="c0gab2tssev6">$650</p>
                  <p className="text-sm text-gray-400 mt-2" data-id="element-192" data-mp="zp7x1eomc50k">Per person</p>
                </div>
              </div>

              <div className="md:col-span-3 p-10" data-id="element-193" data-mp="14oc49zrzfso9">
                <form onSubmit={handleSubmit} data-id="element-194" data-mp="14q5axf2licw9">
                  <div className="space-y-6" data-id="element-195" data-mp="pzy45wlyaibe">
                    <div data-id="element-196" data-mp="px25u766xrmf">
                      <label htmlFor="name" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-197" data-mp="uy9a3w94k8oc">
                        Full Name
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="John Wayne" data-id="element-198" data-mp="1nfv5q26cyyo6" />
                      <ValidationError prefix="Name" field="name" errors={state.errors} data-id="element-199" data-mp="2p6d6euaeulwe" />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-200" data-mp="2y4ouopnt17lo">
                      <div data-id="element-201" data-mp="2t658qp97nvtb">
                        <label htmlFor="title" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-202" data-mp="2ta1dlbv4rfh4">
                          Job Title
                        </label>
                        <input type="text" id="title" name="title" value={formData.title} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="CFO" data-id="element-203" data-mp="sl55yjfzbcjt" />
                        <ValidationError prefix="Job Title" field="title" errors={state.errors} data-id="element-204" data-mp="1gazkr6juzb6p" />
                      </div>
                      <div data-id="element-205" data-mp="3mzw3iuem3tu6">
                        <label htmlFor="company" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-206" data-mp="3n0nutt16f5en">
                          Company
                        </label>
                        <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="Acme Corp" data-id="element-207" data-mp="3eqgjylyp0ltx" />
                        <ValidationError prefix="Company" field="company" errors={state.errors} data-id="element-208" data-mp="3tejnzpt6dng3" />
                      </div>
                    </div>

                    <div data-id="element-209" data-mp="2d1w9mnnn6vks">
                      <label htmlFor="email" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-210" data-mp="2d1czvu85bdhu">
                        Email Address
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="john@example.com" data-id="element-211" data-mp="2jv563u0zv5bm" />
                      <ValidationError prefix="Email" field="email" errors={state.errors} data-id="element-212" data-mp="2yrw7g8u8ar3v" />
                    </div>

                    <div data-id="element-213" data-mp="14f6ebtboplxj">
                      <label htmlFor="phone" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-214" data-mp="14fza5z93ur0w">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="(512) 555-0123" data-id="element-215" data-mp="kl6fluahsayv" />
                      <ValidationError prefix="Phone" field="phone" errors={state.errors} data-id="element-216" data-mp="6k3t5gfl4ynf" />
                    </div>

                    <div className="flex items-start gap-3" data-id="element-217" data-mp="20xlhh5ntdzji">
                      <input type="checkbox" id="smsConsent" name="smsConsent" checked={formData.smsConsent} onChange={handleChange} className="mt-1 w-5 h-5 rounded border-2 border-[#D2691E] text-[#D2691E] focus:ring-[#D2691E] focus:ring-offset-0 cursor-pointer" data-id="element-218" data-mp="1yjzv2nrfmbxz" />
                      <label htmlFor="smsConsent" className="text-sm text-[#556B2F] cursor-pointer" data-id="element-219" data-mp="2i778ojcr3db0">
                        I authorize Commerce CFO Roundtable to send me SMS text
                        messages about event updates, reminders, and related
                        information. Message and data rates may apply. Reply
                        STOP to unsubscribe.
                      </label>
                    </div>
                  </div>

                  <div className="mt-8" data-id="element-220" data-mp="2w6oz135p2ymh">
                    <button type="submit" disabled={state.submitting} className="w-full flex items-center justify-center gap-2 bg-[#D2691E] hover:bg-[#A0522D] text-white font-bold py-4 rounded-lg transition-all shadow-lg hover:shadow-[#D2691E]/30 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-221" data-mp="33joag6h5wbit">
                      {state.submitting ? 'Submitting...' : 'Submit Registration'}
                      {!state.submitting && <ArrowRight size={20} data-id="element-222" data-mp="3rfiw1slauir5" />}
                    </button>
                  </div>
                  <ValidationError errors={state.errors} data-id="element-223" data-mp="3r0nymwx5l0" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}